<template>
    <div class="okraina-retail-ci" :class="{ na: !product }">

        <swiper slidesPerView="auto" :loop="false" :spaceBetween="0" :autoHeight="false" :resistance="false"
            :touchReleaseOnEdges="true" :longSwipes="false" class="mySwiper">

            <swiper-slide class="slide-item">
                <div class="item-inner">
                    <div class="cashback">
                        <okraina-catalog-product-cashback v-if="product" :item="product" />
                    </div>
                    <div class="photo-wrap">
                        <okraina-catalog-product-photo :item="product" @click="goToProduct" />
                    </div>
                    <div class="right-cell">
                        <div class="quantity">{{ parseInt(item.QUANTITY) }} шт.</div>
                        <div class="name" @click="goToProduct">
                            {{ item.NAME }}
                        </div>

                        <div class="price" v-if="product && product.PRICE">
                            <okraina-catalog-product-price :item="product" :showMeasure="false"
                                :quantity="basketItem ? basketItem.quantity : 1" />

                        </div>
                    </div>
                </div>
            </swiper-slide>

            <swiper-slide class="slide-right">

                <div class="action" @click="remove">
                    <span class="icon fi fi-close"></span>
                    <div class="text">Удалить</div>
                </div>


            </swiper-slide>

        </swiper>
    </div>
</template>

<script>
import okrainaCatalogProductPhoto from "@/components/catalog/product.photo.vue";
import okrainaCatalogProductCashback from "@/components/catalog/product.cashback.vue";
import okrainaCatalogProductPrice from "@/components/catalog/product.price.vue";

import bus from "@/plugins/bus";
import rest from "@/plugins/rest";

import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";

import { mapGetters } from "vuex";

export default {
    name: "okraina-retail-cart-item",
    components: {
        okrainaCatalogProductPhoto,
        okrainaCatalogProductCashback,
        okrainaCatalogProductPrice,
        Swiper,
        SwiperSlide
    },
    emits: ["deleted"],
    data() {
        return {

        };
    },
    props: {
        item: {
            type: Object,
            default() {
                return null;
            },
        },
        product: {
            type: Object,
            default() {
                return null;
            },
        },

    },

    computed: {

        ...mapGetters({
            retailShopId: "retail/getShopId"
        }),

        inBasket() {
            return this.$store.getters["retail/inBasket"](this.item.PRODUCT_ID);
        },

        basketItem() {
            return this.$store.getters["retail/getProductInBasket"](this.item.PRODUCT_ID);
        },

        /**
         * Кол-во в общем хранилище данных - чтобы отслеживать из-менение кол-ва у одного и того же товара если их несколько на странице
         */
        basketQuantity() {
            return this.basketItem ? this.basketItem.quantity : 0;
        }
    },

    watch: {
        inBasket: function (newVal) {
            if (!newVal) {
                this.$emit("deleted", this.item.ID);
            }
        },
    },

    methods: {

        /**
         * ПОткрытие карточки товара
         */
        goToProduct() {
            if (this.product && this.product.FIELDS.CODE && !this.isGift) {
                bus.emit("OKRAINA_PRODUCT_MODAL_E_OPEN", {
                    id: this.product.FIELDS.ID,
                    code: this.product.FIELDS.CODE
                });
            }
        },

        /**
         * Удаление позиции
         */
        remove() {

            rest
                .call("retail.basket.delete", {
                    method: "post",
                    data: {
                        PRODUCT_ID: this.item.PRODUCT_ID,
                        SHOP_ID: this.retailShopId
                    },
                })
                .then((data) => {
                    if (data.SUCCESS) {

                        //изменяем кол-во в корзине
                        this.$store.dispatch("retail/updateBasketItem", {
                            id: this.item.PRODUCT_ID,
                            quantity: 0
                        })

                        this.$emit("deleted", this.item.ID);

                    } else {
                        //показываем сообщение об ошибке
                        bus.emit("OKRAINA_MESSAGE_E_SHOW", { message: data.ERROR_TEXT });
                    }
                });


        },

    }
}

</script>

<style lang="scss">
.okraina-retail-ci {
    margin-bottom: 4px;
    margin-left: -8px;
    margin-right: -8px;

    .swiper {
        padding-top: 4px;
    }

    .swiper-wrapper {
        height: auto;
        align-items: stretch;
    }

    .slide-item {
        height: auto;
        padding: 0px 8px;
    }

    .slide-right {
        width: 100px;
        height: auto;
        background-color: var(--color-btn1-background);
        color: var(--color-btn1-text);

    }

    @media (min-width: 600px) {
        .slide-item {
            width: calc(100% - 100px)
        }
    }

    .item-inner {
        position: relative;
        background-color: var(--color-block-background);
        border-radius: 5px;
        display: grid;
        grid-template-columns: 110px 1fr;
        align-items: center;
    }

    .cashback {
        position: absolute;
        top: -2px;
        left: 0px;
        z-index: 2;
    }

    .right-cell {
        padding: 8px;
    }

    .photo-wrap {
        border-radius: 5px 0px 0px 5px;
        overflow: hidden;
        padding: 10px 0px;
        position: relative;
        cursor: pointer;
    }

    .quantity {
        color: var(--color-text-gray);
        font-size: 12px;
        font-weight: 500;
        margin-bottom: 5px;
    }

    .name {
        font-size: 12px;
        font-weight: 500;

        color: var(--color-text-dark);
        cursor: pointer;
        margin-bottom: 10px;
    }

    .action {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        cursor: pointer;

        .text {
            margin-top: 5px;
        }
    }

    /* товар недоступен */
    &.na {

        .photo-wrap,
        .name,
        .price {
            opacity: 0.5;
        }
    }

    /**
            Анимация
        */
    &.fade-move,
    &.fade-enter-active,
    &.fade-leave-active {
        transition: all 0.3s ease;
    }

    &.fade-enter-from,
    &.fade-leave-to {
        opacity: 0;
        transform: translateX(-50px);
    }

    &.fade-leave-active {
        position: absolute;
    }
}
</style>